import createCardItem from './createCardItem';
import Activity from '../../schema/Activity';
import CardItem from '../../schema/viewSchema/CardItem';
import Entity from '../../schema/Entity';
import TxpImages from '../../schema/configSchema/TxpImages';
import TxpStrings from '../../schema/configSchema/TxpStrings';
import TxpDateTimeCallbacks from '../../schema/configSchema/TxpDateTimeCallbacks';

export default function createCardsWithBusStop(
    activities: Activity[],
    entities: { [entityId: string]: Entity },
    showLocation: boolean,
    txpStrings: TxpStrings,
    txpImages?: TxpImages,
    calendarEventIds?: string[],
    txpDateTimeCallbacks?: TxpDateTimeCallbacks
): CardItem[] {
    let cardItems: CardItem[] = [];
    activities.forEach(activityItem => {
        let currentEntity = entities[activityItem.entityId];
        let card = createCardItem(
            activityItem,
            currentEntity,
            true,
            showLocation,
            txpStrings,
            txpImages,
            null,
            calendarEventIds,
            txpDateTimeCallbacks
        );
        cardItems.push(card);
    });
    return cardItems;
}
